<template>
    <div v-if="show">
        <el-card class="box-card" v-if="showForm">
            <h2>Nuevo item de formulario</h2>
            <el-form>
                <!-- tipo de elemento para el formulario -->
                <el-tag v-if="!formName" type="warning" class="tag--custom">El nombre del formulario no puede estar en blanco</el-tag>             
                <el-tag v-if="formModel == 1 && !formEmail" type="warning" class="tag--custom my-4">Añade un email de envío</el-tag>
                <el-tag v-if="!formModel" type="warning" class="tag--custom my-4">Selecciona un tipo de formulario</el-tag>
                
                <template v-if="formName && formModel == 1 && formEmail || formName && formModel == 2">
                    <el-form-item :label="'Tipo'">
                        <!-- Tipo de elemento -->
                        <el-radio-group v-model="form.tipe" >
                            <template v-if="formModel == 1">
                                <el-radio class="my-2 mr-2" border label="text">Texto corto</el-radio>
                                <el-radio class="my-2 mr-2" border label="textarea">Texto largo</el-radio>
                                <el-radio class="my-2 mr-2" border label="number">Númerico</el-radio>
                                <el-radio class="my-2 mr-2" border label="date">Fecha</el-radio>
                                <el-radio class="my-2 mr-2" border label="select">Select</el-radio>
                                <el-radio class="my-2 mr-2" border label="checkbox">Checkbox</el-radio>
                                <el-radio class="my-2 mr-2" border label="radio">Radio</el-radio>
                            </template>
                            <template v-else-if="formModel == 2">
                                <el-radio class="my-2 mr-2" border label="select">Select</el-radio>
                                <el-radio class="my-2 mr-2" border label="checkbox">Checkbox</el-radio>
                                <el-radio class="my-2 mr-2" border label="radio">Radio</el-radio>
                            </template>

                        </el-radio-group>
                        <br />

                        <!-- Grupo de opciones -->
                        <template  v-if="form.tipe && form.tipe == 'select' || form.tipe && form.tipe == 'checkbox' || form.tipe && form.tipe == 'radio'">
                            <br />
                            <el-select v-model="form.option" @change="getSelectOptionsGroup()">
                                <el-option value="0" label="Nuevo"></el-option>
                                <el-option v-for="(o, i) in optionSelect" :key="i" :value="o.id" :label="o.nombre" ></el-option>
                            </el-select>
                        </template>

                        <!-- Tabla con grupo de opciones seleccionado -->
                        <template v-if="form.tipe == 'select' || form.tipe && form.tipe == 'checkbox' || form.tipe && form.tipe == 'radio' && form.option && form.option != '0'">
                            <br />
                            <br />
                            <el-card >
                                <h2>Grupo de opciones seleccionado</h2>
                                <el-table :data="groupOptions" >
                                    <el-table-column prop="item" label="Nombre"></el-table-column>
                                    <el-table-column prop="value" label="Valor"> </el-table-column>
                                </el-table>
                            </el-card>
                            <br>
                        </template>
                    </el-form-item>
                    <!-- Label del elemento -->
                    <el-form-item :label="'Label'">
                        <el-input  v-model="form.label" type="text" ></el-input>
                    </el-form-item>
                    <el-form-item v-if="form.tipe && form.label">
                        <button @click.prevent="addItem()" class="el-button el-button--primary">Añadir elemento al formulario</button>
                    </el-form-item>
                </template>
            </el-form>
        </el-card >
        <el-card class="box-card" v-else>
            <h2>Nuevo grupo de opciones
                <button @click.prevent="atras" class="el-button el-button--info">Volver</button>
            </h2>
            <el-form>
                <el-row type="flex" v-if="!groupId">
                    <el-col :span="8">
                        <el-form-item :label="'Nombre del grupo'">
                            <el-input  v-model="nameGroup" type="text" ></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="1"></el-col>
                    <el-col :span="6">
                        <el-form-item :label="'Añadir'" >
                            <button @click.prevent="saveGroup()" class="el-button el-button--primary">{{btnGroup}}</button>
                        </el-form-item>
                    </el-col>
                </el-row>
                <hr>
                <template v-if="!showTableOptions && groupId"> 
                    <el-row >
                        <h4>Añadir opciones a {{nameGroup}}</h4>
                        <el-col :span="24">
                            <el-form-item :label="'Texto que se mostará'">
                                <el-input  v-model="group.item" type="text" ></el-input>
                            </el-form-item>
                        </el-col>
                        <br />
                        <el-col :span="24">
                            <el-form-item :label="'Valor'">
                                <el-input  v-model="group.value" type="text" ></el-input>
                            </el-form-item>
                        </el-col>
                        <br />
                        <el-col :span="24">
                            <el-form-item :label="'Añadir'" >
                                <button @click.prevent="addItemGroup(group.item, group.value)" class="el-button el-button--primary">{{btnOption}}</button>
                                <button v-if="groupId" @click.prevent="showOptions()" class="el-button ">Ver existente</button>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <template v-if="showTable">
                        <el-table :data="groupOptions" >
                            <el-table-column prop="item" label="Nombre"></el-table-column>
                            <el-table-column prop="value" label="Valor"> </el-table-column>
                            <el-table-column label="Acciones">
                                <template slot-scope="scope">
                                    <el-button size="mini" @click="handleEdit(scope.row)"><i class="el-icon-edit"></i></el-button>
                                    <el-button size="mini" type="danger" @click="handleDelete(scope.row)"><i class="el-icon-delete"></i></el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                    </template>

                </template>
            </el-form>
            <template v-if="showTableOptions">
                <el-row>
                    <el-col :span="24">
                        <button v-if="groupId" @click.prevent="showOptions()" class="el-button el-button--info">Volver a formulario</button>                
                    </el-col>
                </el-row>
                <el-table :data="options" >
                    <el-table-column prop="item" label="Nombre"></el-table-column>
                    <el-table-column prop="value" label="Valor"> </el-table-column>
                    <el-table-column label="Acciones">
                        <template slot-scope="scope">
                            <el-button size="mini" @click="handleAddOption(scope.row)"><i class="el-icon-plus"></i></el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </template>
        </el-card>
    </div>
</template>
<script>
	import ApiService from "@/common/api.service"
    import tablaConPaginador from '@/components/_commons/tablaConPaginador'

    export default {
        name: 'addFieldForm',
        props: ['formModel', 'formName', 'formEmail'],
        created (){
            this.show = true
            this.fecthGroupsOptions()
            this.getOptions()
            this.groupId ? this.fecthGroupOptions() : false;
        },
        watch: {
            groupId (val, oldVal){
				this.fecthGroupOptions()
            },
            showForm (v, o){
                this.fecthGroupsOptions()
            }
        },
        data () {
            return {
                show: false,
                showForm: true,
                items: 0,
                form: {
                    model: false,
                    email: null,
                    tipe: null,
                    label: null,
                    field: null,
                    option: null
                },

                optionSelect: [],
                groupOptions: [],
                options: [],

                btnGroup: 'Crear nuevo grupo',
                btnOption: 'Añadir opción',
                groupId: false,
                groupItems: [],
                nameGroup: '',
                group: {
                    item: null,
                    value: null
                },

                showTable: false,
                showTableOptions: false

            }
        },
        methods: {
            async fecthGroupsOptions() {
				ApiService.post("dashboard/table", {
					table: "formulario_grupos_opciones",
					token: localStorage.getItem("token"),
					project_id: localStorage.getItem("table"),
				}).then(response => {
                    if(response.data != "Algo ha fallado"){
                        this.optionSelect = response.data
                    }
				})
            },
            async fecthGroupOptions(id = null) {
                let a;
                id ? a = id : a = this.groupId;
				ApiService.post("dashboard/listgroupoptions", {
					table: "formulario_opciones_grupo",
					token: localStorage.getItem("token"),
                    project_id: localStorage.getItem("table"),
                    grupo_id: a
				}).then(response => {
                   if(response.data != "Algo ha fallado"){
                       this.groupOptions = response.data
                        setTimeout(() => {
                            this.showTable = true
                        }, 200);

                    }
				})
            },
            async getOptions() {
				ApiService.post("dashboard/table", {
					table: "formulario_opciones_grupo",
					token: localStorage.getItem("token"),
					project_id: localStorage.getItem("table"),
				}).then(response => {
                    if(response.data != "Algo ha fallado"){
                        this.options = response.data
                        setTimeout(() => {
                            this.showTable = true
                        }, 200);
                    }
				})
            },
        
            async createdGroup () {
				ApiService.post("dashboard/editform", {
					table: "formulario_grupos_opciones",
					token: localStorage.getItem("token"),
					project_id: localStorage.getItem("table"),
					form: {nombre: this.nameGroup},
                }).then(response => {
                    if(response.data != "Algo ha fallado"){
                        this.groupId = response.data
                        this.btnGroup = 'Editar nombre grupo'
                        this.msg('success', 'Grupo creado correctamente')
                    }else{
                        this.msg('error', 'Algo ha falldo y el grupo no se ha podido crear')
                    }
                })
            },
            async editdGroup () {
				ApiService.post("dashboard/editform", {
					table: "formulario_grupos_opciones",
					token: localStorage.getItem("token"),
					project_id: localStorage.getItem("table"),
                    form: {nombre: this.nameGroup},
                    id: this.groupId
                }).then(response => {
                    if(response.data != "Algo ha fallado"){
                        this.groupId = response.data
                        this.msg('success', 'Grupo modificado correctamente')
                    }else{
                        this.msg('error', 'Algo ha falldo y el grupo no se ha podido modificar')
                    }
                })
            },
            async addOptions() {
				ApiService.post("dashboard/editform", {
					table: "formulario_opciones_grupo",
					token: localStorage.getItem("token"),
					project_id: localStorage.getItem("table"),
					form: this.groupItems,
                }).then(response => {
                    if(response.data != "Algo ha fallado"){
                        this.addGroupOption(response.data)
                        this.msg('success', 'opción añadida correctamente')
                    }else{
                        return this.msg('error', 'Algo ha falldo y la opción no ha podido ser creada')
                    }
                })
            },
            async addGroupOption(o) {
				ApiService.post("dashboard/editform", {
					table: "formulario_grupo_opcion",
					token: localStorage.getItem("token"),
					project_id: localStorage.getItem("table"),
					form: {grupo_id: this.groupId , opcion_id: o},
                }).then(response => 
                    this.fecthGroupOptions()
                )
            },
            saveGroup(){
                !this.groupId && this.nameGroup ? this.createdGroup() : this.editGroup();
            },
            checkItemGroup(a, b){
                if(!a){
                    this.msg('error', 'Para poder continuar, completa el campo "ITEM"')
                    return false
                }else if(!b){
                    this.msg('error', 'Para poder continuar, completa el campo "VALOR"')
                    return false
                }
                return true
            },
            addItemGroup(a, b) {
                if(!this.groupId && this.nameGroup){
                    this.createdGroup()
                    this.checkItemGroup(a, b) ? this.insertItemGroup(a, b) : false;      
                }else if(!this.groupId && !this.nameGroup){
                    this.msg('error', 'Para poder continuar, introduce un nombre de grupo')
                }else{
                    this.checkItemGroup(a, b) ? this.insertItemGroup(a, b) : false;   
                }
            },
            insertItemGroup(a, b) {
                setTimeout(() => {
                    this.showTable = false
                    this.groupItems = {item:a,  value:b}
                    this.group.item = null
                    this.group.value = null
                    this.addOptions()                    
                }, 100);
            },
            showOptions(){
                this.showTableOptions = !this.showTableOptions
                !this.showTableOptions ? this.fecthGroupOptions() : false; 
            },
            handleEdit(row) {

            },
            handleDelete(row) {

            },
            handleAddOption (row) { 
                this.addGroupOption(row.id)
            },
            msg(type, message) {
                this.$root.$emit('mensaje', type, message)
            },
            getSelectOptionsGroup(){
                this.form.option == 0 ? this.showForm = false : false;
                setTimeout(() => {
                    this.fecthGroupOptions(this.form.option)
                }, 200);
            },
            atras(){
                this.showForm = true
            },
            addItem(){
                this.form.value  = 'frm_' + this.items
                this.$root.$emit('addField', this.form)
                this.items += 1
                this.form = {}
            }
        }
    }
</script>

<style>
    .tag--custom {
        width: 100%;
        font-size: 14px !important;
        padding: 10px;
        height: 50px;
    }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/pages/templates/addFieldForm.vue